import React, { useEffect } from 'react';
import {
  Modal,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Button,
  Grid
} from '@mui/material';
import DataTable from 'react-data-table-component';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';

const AudioSearchModal = ({ open, onClose, loading, audioData, error, hubspotId, onSearchAudio }) => {

  // Ejecutar la búsqueda de audio cuando el modal se abra
  useEffect(() => {
    if (open && hubspotId) {
      onSearchAudio(); // Llama a la función de búsqueda de audio cuando el modal se abre
    }
  }, [open, hubspotId, onSearchAudio]);

  // Manejar caso cuando audioData sea null o undefined
  const safeAudioData = audioData || []; // Si audioData es null, inicializar como []

  // Filtrar solo los archivos que terminan en .wav
  //const wavAudioData = safeAudioData.filter(item => item.endsWith('.wav', '.mp3'));
  const wavAudioData = safeAudioData.some(item => item.endsWith('.mp3'))
    ? safeAudioData.filter(item => item.endsWith('.mp3'))
    : safeAudioData.some(item => item.endsWith('.wav'))
      ? safeAudioData.filter(item => item.endsWith('.wav'))
      : safeAudioData.some(item => item.endsWith('.gsm'))
        ? safeAudioData.filter(item => item.endsWith('.gsm'))
        : [];

  // Función para extraer la fecha del archivo y formatearla como DD/MM/YYYY
  const extractDate = (id) => {
    if (!id) return '';  // Verifica si id es nulo o indefinido
    const dateMatch = id.match(/date\.(\d{4}-\d{2}-\d{2})-\d{2}-\d{2}-\d{2}/);
    if (dateMatch) {
      const dateParts = dateMatch[1].split('-');
      return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`; // Formato DD/MM/YYYY
    }
    return 'Fecha no disponible';
  };

  // Función para extraer el teléfono del archivo
  const extractPhone = (id) => {
    if (!id) return ''; // Asegura que id no sea indefinido o null
    const phoneMatch = id.match(/tel\.(\d+)/);
    return phoneMatch ? phoneMatch[1] : 'Teléfono no disponible';
  };

  // Función para extraer el ID del archivo
  const extractId = (id) => {
    if (!id) return ''; // Asegura que id no sea indefinido o null
    const idMatch = id.match(/id\.(\d+\.\d+\.\d+\.\d+)/);
    return idMatch ? idMatch[1] : 'ID no disponible';
  };

  const extractExt = (id) => {
    if (!id) return ''; // Asegura que id no sea indefinido o null
    const extensionMatch = id.match(/\.(mp3|wav|gsm)$/); // Busca extensiones mp3, wav o gsm al final
    return extensionMatch ? extensionMatch[1] : 'Tipo Archivo'; // Devuelve la extensión si se encuentra
  };


  const columns = [
    {
      name: 'Fecha',
      selector: row => extractDate(row), // Extrae y formatea la fecha
      sortable: true,
      width: 'auto',
    },
    {
      name: 'Teléfono',
      selector: row => extractPhone(row), // Extrae el teléfono
      sortable: true,
      width: 'auto',
    },
    {
      name: ' Registro ',
      selector: row => extractId(row), // Extrae el ID
      sortable: true,
      width: 'auto',

    },
    {
      name: 'Tipo Extension',
      selector: row => extractExt(row), // Extrae el ID
      sortable: true,
      width: 'auto',

    },

    {
      width: 'auto',
      name: 'Descargar',
      cell: row => (
        <IconButton
          href={row}
          download
          aria-label="download"
        >
          <DownloadIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Paper elevation={3} sx={{ padding: 2, width: '60%' }}>
          <Typography variant="h5" gutterBottom>
            Resultados Busqueda Audio
          </Typography>

          {loading ? (
            <CircularProgress />
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            <DataTable
              columns={columns}
              data={wavAudioData}

            />
          )}

          <Grid item xs={12} >
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button variant="contained" color="secondary" onClick={onClose} >
                Cerrar
              </Button>
            </Box>

          </Grid>

        </Paper>
      </Box>
    </Modal>
  );
};

export default AudioSearchModal;
